import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import I18n from '@module/i18n';
import Icon from '@component/icon';
import Helper from '@app/helper';

import { EXPERIMENT_RECEIVING_VARIANT_APP_BAR } from '@constant/experiments';

const ReceivingExperimentVariantAppbar = ({ onClick, shortUrl }) => {
  const handleClick = useCallback(() =>
    onClick(EXPERIMENT_RECEIVING_VARIANT_APP_BAR)
  );
  return (
    <div className="downloader-receiving-experiment-appbar">
      <div className="downloader-receiving-experiment-appbar__container">
        <div className="downloader-receiving-experiment-appbar__logo">
          <Icon type="Collect" />
        </div>

        <div className="downloader-receiving-experiment-appbar__text">
          <h4>{I18n.t('notification.mobile_app_banner_title')}</h4>
          <p>{I18n.t('notification.collect_app_banner_desc')}</p>
        </div>
      </div>

      <div className="downloader-receiving-experiment-appbar__buttons">
        <a
          onClick={handleClick}
          className="button button--enabled"
          href={
            Helper.getOpenInAppUri({
              shortUrl,
              utmContent: EXPERIMENT_RECEIVING_VARIANT_APP_BAR,
            }).href
          }
        >
          {I18n.t('transfer.buttons.openincollectapp')}
        </a>
      </div>
    </div>
  );
};

ReceivingExperimentVariantAppbar.propTypes = {
  onClick: PropTypes.func.isRequired,
  shortUrl: PropTypes.string.isRequired,
};

export default ReceivingExperimentVariantAppbar;
